import { utilHelper } from "../../_helpers";

const relativeUrl = 'api/jobHistory'

export const jobHistoryService = {
    search,
    saveItem,
    updateItem,
    deleteItem,
    getOptions,
    getFilterOptions
};

//search
function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data:data, showAlert:false })
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data:data });
}

//delete
function deleteItem(id,fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{});
}

function getOptions(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getOptions`, 'POST', { data:data, showAlert:false })
}

function getFilterOptions() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getFilterOptions`, 'POST', { showAlert:false })
}